module.exports = "/_next/static/images/imageFooter-ffefc553dcf0e630c71597a3fbad0207.svg";